export default __webpack_public_path__ + "static/thousands-brands.url-186bb0bd42161054ac3ab498d3db6250.svg";